module.exports = __webpack_public_path__ + "img/circuit-network.6c5fbd0b.png";